import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getUserRewardListRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
  pageNum: number; // 页码，从1开始 ,
  pageSize: number; //每页记录数，1-100
}

export interface getUserRewardListVO {
  rwdDate?: string; //日期  ,
  reward?: string; // 奖品描述 ,
}

interface getInvRewardListResponse extends BaseResponse {
  Data: getUserRewardListVO[];
}

/**
 * 获取邀请奖励详情列表
 * @param params
 * @returns
 */
export async function getUserRewardList(request: getUserRewardListRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvMulRewardList');
  return DsbcApi.fetch<getInvRewardListResponse>(url, request, true, options);
}
